/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {ConfirmModalCheck} from './confirm-modal-check.model';
/**
 * @deprecated
 */
export class ConfirmModalManualChecks {
    title: string;
    inputs: ConfirmModalCheck[] = [];
}
